import * as types from '../actionType'

const initialState = []

const userBookAgain = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_POST_BOOKAGAIN_ORDER:
            return action.payload
        default:
            return state
    }
}


export { userBookAgain }